import { z } from "zod";

export const visitSummarizationEventSchema = z.discriminatedUnion("type", [
  z.object({
    type: z.literal("summarization_chunk"),
    data: z.object({ result: z.string() }),
  }),
  z.object({
    type: z.literal("summarization_final"),
    data: z.object({ result: z.string() }),
  }),
  z.object({
    type: z.literal("summarization_error"),
    data: z.object({ error: z.literal("Summarization unavailable") }),
  }),
]);
export type VisitSummarizationEvent = z.output<
  typeof visitSummarizationEventSchema
>;
